export default {"src":"/_next/static/media/game-hero-bg.d73ec9fe.svg","height":405,"width":439,"blurWidth":0,"blurHeight":0};